import {TrackingStatus} from 'types';
import {getStatusLabel} from '../../useTracking';
import {StatusIcon} from './StatusIcon';
import styles from './StatusHeader.module.scss';

type Props = {
  status?: TrackingStatus;
  driverName: string;
  eta: string;
  trackingNumber: number;
};

const getInitials = (name: string): string => {
  if (!name) return '?';
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase();
};

function StatusHeader({status, driverName, eta, trackingNumber}: Props) {
  const statusLabel = getStatusLabel(status ?? 'delivering');

  return (
    <div className={styles.container}>
      <div className={styles.statusSection}>
        <div
          className={`${styles.statusBadge} ${
            styles[status?.replaceAll('_', '') ?? '']
          }`}
        >
          <StatusIcon status={status ?? 'delivering'} />
          <span>{statusLabel}</span>
        </div>
        <span className={styles.trackingNumber}>Order #{trackingNumber}</span>
      </div>

      {driverName && (
        <div className={styles.infoSection}>
          <div className={styles.driverInfo}>
            <div className={styles.driverAvatar}>{getInitials(driverName)}</div>
            <div className={styles.driverDetails}>
              <span className={styles.driverName}>{driverName}</span>
              <span className={styles.driverVehicle}>Your Driver</span>
            </div>
          </div>

          {eta && (
            <div className={styles.etaSection}>
              <span className={styles.etaLabel}>Estimated Arrival</span>
              <span className={styles.etaTime}>{eta}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default StatusHeader;
